import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BusyService } from "~app/common/components/busy/busy.service";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { GruppForm } from "../sysadm-checklist-forms";
import { ChecklistGruppAdminDTO } from "../sysadm.checklista.models";
import { SysdamChecklistaService } from "../sysdam-checklista.service";
@Component({
    selector: "rask-sysadm-laggtill-grupp",
    imports: [RaskCommonModule],
    templateUrl: "./sysadm-laggtill-grupp.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./sysadm-laggtill-grupp.component.scss"
})
export class SysadmLaggtillGruppComponent implements OnInit {
    protected gruppForm: GruppForm;
    private readonly fb = inject(FormBuilder);
    private readonly modal = inject(NgbActiveModal);
    private readonly busyService = inject(BusyService);
    private readonly sysdamChecklistaService = inject(SysdamChecklistaService);

    ngOnInit(): void {
        this.gruppForm = this.fb.group({
            gruppNamn: [
                "",
                Validators.required
            ]
        });
    }

    protected onSave() {
        const grupp = this.mapFromForm();
        const work = this.sysdamChecklistaService.createChecklistGrupp(grupp);
        const response$ = this.busyService.addWork(work);
        response$.subscribe((result) =>
            this.modal.close(result));
    }

    protected canSave() {
        return !this.gruppForm.invalid;
    }

    protected onCancel() {
        this.modal.close();
    }

    private mapFromForm(): ChecklistGruppAdminDTO {
        return {
            gruppNamn: this.gruppForm.get("gruppNamn").value
        } as ChecklistGruppAdminDTO;
    }
}
